import React, { useState } from "react";

const SettingTab = ({ handleLayoutChange, selectedLayout,updateBusinessHoursTabData,businessHoursTabData }) => {
    const [languageType, setLanguageType] = useState(businessHoursTabData.language_type);
    const [languageTypeDropdownOpen, setLanguageTypeDropdownOpen] = useState(false);
    const [timeZone, setTimeZone] = useState(businessHoursTabData.time_zone);
    const [timeZoneDropdownOpen, setTimeZoneDropdownOpen] = useState(false);
    const [timeFormat, setTimeFormat] = useState(businessHoursTabData.time_format);
    const [timeFormatDropdownOpen, setTimeFormatDropdownOpen] = useState(false);
    const [firstDayOfTheWeek, setFirstDayOfTheWeek] = useState(businessHoursTabData.first_day_of_the_week);
    const [firstDayOfTheWeekDropdownOpen, setFirstDayOfTheWeekDropdownOpen] = useState(false);
    const [dayAndMonthFormat, setDayAndMonthFormat] = useState(businessHoursTabData.day_and_month_format);
    const [dayAndMonthFormatDropdownOpen, setDayAndMonthFormatDropdownOpen] = useState(false);
    

    // Handlers Language Type Change
    const handleLanguageTypeChange = (type) => {
        setLanguageType(type);
        updateBusinessHoursTabData(prev => ({
            ...prev,
            language_type: type
        }));
        setLanguageTypeDropdownOpen(false);
    };

    // Handlers Time Zone Change
    const handleTimeZoneChange = (type) => {
        setTimeZone(type);
        updateBusinessHoursTabData(prev => ({
            ...prev,
            time_zone: type
        }));
        setTimeZoneDropdownOpen(false);
    };

     // Handlers Time Format Change
     const handleTimeFormatChange = (type) => {
        setTimeFormat(type);
        updateBusinessHoursTabData(prev => ({
            ...prev,
            time_format: type
        }));
        setTimeFormatDropdownOpen(false);
    };

    // Handlers First Day Of The Week Change
    const handleFirstDayOfTheWeekChange = (type) => {
        setFirstDayOfTheWeek(type);
        updateBusinessHoursTabData(prev => ({
            ...prev,
            first_day_of_the_week: type
        }));
        setFirstDayOfTheWeekDropdownOpen(false);
    };

    // Handlers Day And Month Format Change
    const handleDayAndMonthFormatChange = (type) => {
        setDayAndMonthFormat(type);
        updateBusinessHoursTabData(prev => ({
            ...prev,
            day_and_month_format: type
        }));
        setDayAndMonthFormatDropdownOpen(false);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Settings</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Language</span>
                    <div className="color-pikr-box" onClick={() => setLanguageTypeDropdownOpen(!languageTypeDropdownOpen)}>
                        <em>{languageType}</em>
                        {languageTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["English"].map((type) => (
                                    <li key={type} onClick={() => handleLanguageTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Time Zone</span>
                    <div className="color-pikr-box" onClick={() => setTimeZoneDropdownOpen(!timeZoneDropdownOpen)}>
                        <em>{timeZone}</em>
                        {timeZoneDropdownOpen && (
                            <ul className="dropdown-list">
                                {["(GMT+05:30) Asia/Kolkata"].map((type) => (
                                    <li key={type} onClick={() => handleTimeZoneChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Time Format</span>
                    <div className="color-pikr-box" onClick={() => setTimeFormatDropdownOpen(!timeFormatDropdownOpen)}>
                        <em>{timeFormat}</em>
                        {timeFormatDropdownOpen && (
                            <ul className="dropdown-list">
                                {["12-hour"].map((type) => (
                                    <li key={type} onClick={() => handleTimeFormatChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="box-header-row">
                    <span>First Day of the Week</span>
                    <div className="color-pikr-box" onClick={() => setFirstDayOfTheWeekDropdownOpen(!firstDayOfTheWeekDropdownOpen)}>
                        <em>{firstDayOfTheWeek}</em>
                        {firstDayOfTheWeekDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Monday"].map((type) => (
                                    <li key={type} onClick={() => handleFirstDayOfTheWeekChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Day and Month Format</span>
                    <div className="color-pikr-box" onClick={() => setDayAndMonthFormatDropdownOpen(!dayAndMonthFormatDropdownOpen)}>
                        <em>{dayAndMonthFormat}</em>
                        {dayAndMonthFormatDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Full (Monday, January)"].map((type) => (
                                    <li key={type} onClick={() => handleDayAndMonthFormatChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingTab;